export default "__VITE_ASSET__BKq0Nm4Q__"